import React, { createContext } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { RedeemToken, RedeemTokenTypes } from './views/RedeemToken';
import { RequestResetPassword } from './views/RequestResetPassword';
import { RedeemEmailConfirmation } from './views/RedeemEmailConfirmation';
import { useTr8 } from './hooks/useTr8';
import cc_logo from './camcog_master_logo.jpg';
import logo from './logo.png';
import './styles.scss';

export const Tr8Context = createContext(
  (s: string, obj?: Map<string, string>) => s,
);

export const paths = {
  home: '/',
  requestPasswordReset: 'psswd-rqst',
  redeemPasswordReset: 'psswd-rdm',
  redeemEmailConfirmation: 'email-confirm',
  redeemNewUserToken: 'new-user',
};

function App() {
  const tr8 = useTr8('en_US');

  return (
    <Tr8Context.Provider value={tr8}>
      <HashRouter basename="/">
        <div className="ccn-mgmnt-page" data-test-id="connect-password-reset">
          <div className="content-wrapper">
            <div className="ccn-brand-header">
              <img src={cc_logo} alt="cambridge-cognition-logo" />
            </div>
            <div className="formWrapper">
              <img src={logo} alt="cantab-logo" className="ccn-cantab-logo" />
              <Routes>
                <Route
                  path={paths.redeemEmailConfirmation}
                  element={<RedeemEmailConfirmation />}
                />
                <Route
                  path={paths.requestPasswordReset}
                  element={<RequestResetPassword />}
                />
                <Route
                  path={paths.redeemPasswordReset}
                  element={
                    <RedeemToken tokenType={RedeemTokenTypes.PasswordReset} />
                  }
                />
                <Route
                  path={paths.redeemNewUserToken}
                  element={<RedeemToken tokenType={RedeemTokenTypes.NewUser} />}
                />
              </Routes>
            </div>
          </div>
        </div>
      </HashRouter>
    </Tr8Context.Provider>
  );
}

export default App;
